<!-- 工单质检 -->
<template>
  <div>
    <a-spin :spinning="loading">
      <a-table
        :pagination="false"
        :rowKey="(record, index) => index"
        :columns="columns"
        :data-source="list"
        :transformCellText="({ text }) => text ?? '--'"
      >
        <template #traceOrReachRule="{ text }">
          <template v-if="text?.length">
            <div v-for="(item, index) in text" :key="index">{{ item }}</div>
          </template>
          <span v-else>--</span>
        </template>
        <template #supplementExplanation="{ text }">
          <template v-if="text?.length">
            <div v-for="(item, index) in text" :key="index">{{ item }}</div>
          </template>
          <span v-else>--</span>
        </template>
        <template #workOrderQualityProof="{ text }">
          <template v-if="text.examineStatus === null">--</template>
          <template v-else>
            <a-button type="link" @click="goDetails(text)">查看</a-button>
            <template v-if="text.examineStatus">
              {{ ['', '通过', '未通过'][text?.examineStatus ?? 0] }}
            </template>
            <template v-else>
              <a-button type="link" @click="check(text, 1)">审核通过</a-button>
              <a-button type="link" @click="check(text, 2)">审核不通过</a-button>
            </template>
          </template>
        </template>
      </a-table>
    </a-spin>
    <EvidenceDetails ref="evidenceDetailsRef" />
  </div>
</template>
<script setup>
import { message } from 'ant-design-vue'
import EvidenceDetails from './evidenceDetails.vue'
import { columns } from './config'
import { defineProps, ref, onMounted } from 'vue'
import { queryQualityInspectionProof, approveQualityInspectionProof } from '@/api/Todo/bdWorkorder'
const evidenceDetailsRef = ref(null)
const list = ref([])
const loading = ref(false)
const props = defineProps({
  workOrderId: {
    type: [String, Number],
    default: ''
  },
  id: {
    type: [String, Number],
    default: null
  }
})
const getInspectionData = () => {
  loading.value = true
  const params = {
    workOrderId: props.workOrderId,
    adSubTaskId: props.id
  }
  queryQualityInspectionProof(params)
    .then(res => {
      list.value = res ?? []
    })
    .catch(() => {
      list.value = []
    })
    .finally(() => {
      loading.value = false
    })
}
// 查看凭证
const goDetails = item => {
  evidenceDetailsRef?.value?.initModal(item)
}
// 审核（无需二次确认弹窗）
const check = (record, status) => {
  if (!record.id) return false
  approveQualityInspectionProof({
    proofId: record?.id,
    examineStatus: status
  })
    .then(() => {
      message.success('操作成功！')
    })
    .catch(() => {
      //
    })
    .finally(() => {
      getInspectionData()
    })
}
onMounted(() => {
  getInspectionData()
})
</script>
<style scoped lang="scss"></style>
